// 判断是什么类型

/** 判断是否为数组
 * @method isArray
 * @param {any} arry
 */
export const isArray = (arry) => {
  return Object.prototype.toString.call(arry) === '[object Array]'
}

/** 判断是否为纯对象
 * @method isObject
 * @param {any} obj
 */
export const isObject = (obj) => {
  return Object.prototype.toString.call(obj) === '[object Object]'
}

/** 判断是否为函数
 * @method isFunction
 * @param {any} fun
 */
export const isFunction = (fun) => {
  return typeof fun === 'function'
}

/** 判断是否是ipad的浏览器
 * @method isIpad 判断是否是ipad的浏览器
 */
export const isIpad = () => {
  var ua = navigator.userAgent.toLowerCase()
  var macApp = ua.match(/Macintosh/i) != null
  if (/ipad/i.test(ua)) {
    return true
  } else if (/ipad|tablet|android/i.test(ua) && !/mobile/i.test(ua)) {
    return true
  } else if (macApp && navigator.maxTouchPoints > 1) {
    return true
  } else {
    return false
  }
}



// WEBPACK FOOTER //
// ./src/assets/utils/typeof.js